import { render, staticRenderFns } from "./splitDetailView.vue?vue&type=template&id=6ec1d71c&"
import script from "./splitDetailView.vue?vue&type=script&lang=js&"
export * from "./splitDetailView.vue?vue&type=script&lang=js&"
import style0 from "./splitDetailView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VFlex,VLayout,VSelect,VSimpleTable})
